import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import InsightsIcon from '@mui/icons-material/Insights';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ObjectMap } from 'mf_core/query';

type Props = {
  insightData: ObjectMap;
};

export default function TopInsightDetails(props: Props) {
  const { insightData } = props;
  return (
    <>
      <StyledInsightDetailsStackWrapper
        alignItems="center"
        direction="row"
        spacing={1}
      >
        <Stack direction="row" spacing={1} width="100%">
          <InsightsIcon />
          <Stack spacing={1} width="100%">
            <Stack
              alignItems="center"
              direction="row"
              justifyContent="space-between"
            >
              <Typography sx={{ fontWeight: 600, pl: 1.3 }} variant="body1">
                {insightData?.title}
              </Typography>
              <Button
                size="small"
                sx={{ display: 'none', textTransform: 'none' }}
                variant="text"
              >
                Dismiss
              </Button>
            </Stack>
            <Typography sx={{ pl: 1.3 }} variant="body1">
              {insightData?.description}
            </Typography>
            <Box component="div">
              <Button
                size="small"
                sx={{ display: 'none', textTransform: 'none' }}
                variant="text"
              >
                View all information
              </Button>
            </Box>
          </Stack>
        </Stack>
      </StyledInsightDetailsStackWrapper>
    </>
  );
}

const StyledInsightDetailsStackWrapper = styled(Stack)(({ theme }) => ({
  '&: hover': {
    background: '#f4f4f4',
  },
  borderBottom: '1px solid #ececec',
  maxWidth: 650,
  padding: theme.spacing(1),
  paddingBottom: theme.spacing(2),
}));
